import { render } from "./CenikItem.vue?vue&type=template&id=9392d98c&scoped=true&ts=true"
import script from "./CenikItem.vue?vue&type=script&lang=ts"
export * from "./CenikItem.vue?vue&type=script&lang=ts"

import "./CenikItem.vue?vue&type=style&index=0&id=9392d98c&lang=scss&scoped=true"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9392d98c"]])

export default __exports__